"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccordionAnimation = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _framerMotion = require("framer-motion");
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useAccordionAnimation = exports.useAccordionAnimation = function useAccordionAnimation(props) {
  var isBeingKeptMounted = !!props;
  var isExpanded = props === null || props === void 0 ? void 0 : props.isExpanded;
  var overflow = (0, _framerMotion.useMotionValue)(null);
  var display = (0, _framerMotion.useMotionValue)(isBeingKeptMounted && isExpanded ? null : 'none');
  return (0, _react.useMemo)(function () {
    var commonProps = {
      transition: {
        duration: 0.3,
        ease: [0.8, 0, 0.2, 1]
      },
      style: {
        overflow: overflow,
        display: display
      },
      // this is needed because we want to hide overflow only while animating.
      // If overflow was hidden all the time, dropdowns/popovers near the bottom of the item will be cut off.
      onAnimationStart: function onAnimationStart() {
        overflow.set('hidden');
        display.set(null);
      },
      onAnimationComplete: function onAnimationComplete(animation) {
        overflow.set(null);
        if (animation === COLLAPSED) {
          display.set('none');
        }
      }
    };
    return isBeingKeptMounted ? _objectSpread(_objectSpread({}, commonProps), {}, {
      initial: false,
      animate: isExpanded ? OPEN : COLLAPSED
    }) : _objectSpread(_objectSpread({}, commonProps), {}, {
      initial: COLLAPSED,
      animate: OPEN,
      exit: COLLAPSED
    });
  }, [isBeingKeptMounted, isExpanded, overflow, display]);
};
var OPEN = {
  height: 'auto'
};
var COLLAPSED = {
  height: 0
};
//# sourceMappingURL=useAccordionAnimation.js.map